import { render, staticRenderFns } from "./NotifiedPeopleProperty.vue?vue&type=template&id=66699e5e"
import script from "./NotifiedPeopleProperty.vue?vue&type=script&lang=js"
export * from "./NotifiedPeopleProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports